export default __webpack_public_path__ + "static/media/right-arrow-icon.a2d1ebc4.svg";